import { Grid, Typography } from "@mui/material";

const Research = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    My Research
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{mb: 1}}>
                <Typography variant='body1' textAlign={'justify'}>
                My research focuses on enhancing security in Mobile Cyber-Physical Systems
                 by identifying vulnerabilities and developing robust defense mechanisms.
                  I also explore Mobile Cloud Computing, aiming to secure data and ensure
                   privacy during cloud interactions. My work in cybersecurity involves
                    creating algorithms and systems to protect against a range of cyber threats.
                     Additionally, I delve into Digital Forensics to investigate data breaches
                      and develop tools for evidence extraction.
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Publications
                </Typography>
            </Grid>
            
            <Grid item xs={12} sx={{mb: 1}}>
                <ul>
                    <li>2023, To Jam or Not to Jam: Hindering State Alignment through Selective Jamming <Typography component='span' sx={{color: 'red', textDecoration: 'underline'}}>Under Review</Typography></li>
                    <li>2020, An efficient parallel genetic algorithm solution for vehicle routing problem in cloud implementation of the intelligent transportation systems. &nbsp;<a href="https://link.springer.com/article/10.1186/s13677-020-0157-4">[Link]</a></li>
                </ul>
            </Grid>   
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Research Interests
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{mb: 1}}>
                <ul>
                    <li>Security Aspects in Mobile Cyber-Physical Systems</li>
                    <li>Mobile Cloud Computing</li>
                    <li>Cybersecurity</li>
                    <li>Digital Forensics</li>
                </ul>
            </Grid>                      
        </Grid>
    )
};

export default Research;